import React, { useState } from 'react';
import { KeyRound } from 'lucide-react';
import api from '../services/api';
import useAuthStore from '../store/authStore';
import useUIStore from '../store/uiStore';

const ChangePasswordPage = () => {
  const { user } = useAuthStore();
  const { showToast } = useUIStore();
  const [form, setForm] = useState({ old_password: '', new_password: '', confirm_password: '' });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.new_password.length < 6) {
      showToast('New password must be at least 6 characters', 'error');
      return;
    }
    if (form.new_password !== form.confirm_password) {
      showToast('New password and confirmation do not match', 'error');
      return;
    }

    setSubmitting(true);
    try {
      await api.put('/auth/change-password', {
        user_id: user.id,
        old_password: form.old_password,
        new_password: form.new_password,
      });
      showToast('Password changed successfully', 'success');
      setForm({ old_password: '', new_password: '', confirm_password: '' });
    } catch (error) {
      showToast(error.response?.data?.detail || 'Failed to change password', 'error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto p-4 md:p-6">
      <div className="flex items-center gap-2 mb-6">
        <KeyRound size={20} className="text-white" />
        <h1 className="text-xl font-semibold text-white">Change Password</h1>
      </div>

      <form onSubmit={handleSubmit} className="glass-card p-5 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Current Password</label>
          <input
            type="password"
            required
            value={form.old_password}
            onChange={handleChange('old_password')}
            className="w-full border border-gray-300 rounded px-3 py-2 text-sm"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">New Password</label>
          <input
            type="password"
            required
            minLength={6}
            value={form.new_password}
            onChange={handleChange('new_password')}
            className="w-full border border-gray-300 rounded px-3 py-2 text-sm"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Confirm New Password</label>
          <input
            type="password"
            required
            minLength={6}
            value={form.confirm_password}
            onChange={handleChange('confirm_password')}
            className="w-full border border-gray-300 rounded px-3 py-2 text-sm"
          />
        </div>
        <button
          type="submit"
          disabled={submitting}
          className="w-full bg-komal-blue hover:bg-komal-blue/90 disabled:opacity-50 text-white font-semibold py-2 rounded text-sm"
        >
          {submitting ? 'Changing...' : 'Change Password'}
        </button>
      </form>
    </div>
  );
};

export default ChangePasswordPage;
